import { RouterView } from "vue-router";
import DownloadRouting from "./download/download.routing";
import { LibraryReportRouting } from "./library-report/library-report.routing";
import { AccessReportRouting } from "./access-report/access-report.routing";
import { accountsReceivableRouting } from "./project-receivable/project-receivable.routing";
import { ProjectRepotRouting } from "./project-repot/project-repot.routing";
import {LaborWageRouting} from "./labor-wage/labor-wage.routing"
import {LaborOrderStatisticsRouting} from "@/views/report-center/labor-order-statistics/labor-order-statistics.routing";
import {LaborCostDetailsRouting} from './labor-cost-details/labor-cost-details.routing'
import {projectPayableRouting} from './project-payable/project-payable.routing'
import {PurchaseOrderRouting} from './purchase-order/purchase-order.routing'
import {ProjectCostSummaryRouting} from './project-cost-summary/project-cost-summary.routing'
import {capitalDetailRouting} from './capital-detail/capital-detail.routing'

// 项目支出明细
import { ProjectPayDetails } from "./project-pay-details/project-pay-details.routing";
import { CooperationCompanyReport } from "./cooperation-company-report/cooperation-company-report.routing";
export const ReportCenterRouting = {
  path: "/report-center",
  name: "report-center",
  redirect: "/report-center/download",
  component: RouterView,
  meta: { title: "报表中心", icon: "report" },

  children: [...DownloadRouting, ...LibraryReportRouting, ...AccessReportRouting,...ProjectRepotRouting,...LaborWageRouting,...LaborOrderStatisticsRouting,...LaborCostDetailsRouting,...ProjectPayDetails,...accountsReceivableRouting,...projectPayableRouting,...CooperationCompanyReport, ...PurchaseOrderRouting, ...ProjectCostSummaryRouting, ...capitalDetailRouting],
};
